import { Icon } from "semantic-ui-react";

import { PASSWORD_STRENGTH_THRESHOLD } from "modules/Login/components";

type PasswordCheckMarkIconProps = {
  type: "new_password" | "confirm_password";
  strength: number | null;
  newPassword?: string;
  newPasswordConfirm?: string;
};

export const PasswordCheckMarkIcon = ({ type, newPassword, newPasswordConfirm, strength }: PasswordCheckMarkIconProps) => {
  if (type === "new_password" && newPassword && newPassword.length > 0) {
    if (strength && strength >= PASSWORD_STRENGTH_THRESHOLD) return <Icon className="checkIcon" name="check circle outline" />;
    return <Icon className="crossIcon circle xmark" />;
  }

  if (type === "confirm_password" && newPasswordConfirm && newPasswordConfirm.length > 0) {
    if (strength && strength >= PASSWORD_STRENGTH_THRESHOLD && newPassword === newPasswordConfirm) return <Icon className="checkIcon" name="check circle outline" />;
    return <Icon className="crossIcon circle xmark" />;
  }
};
